import { MART_PRODUCT_ACTION_TYPE, MartProductActions } from './martProduct-type';
import { RootState } from '../../../../redux/root-reducer';

export enum MART_PRODUCT_STATE_KEY {
  MART_PRODUCT = 'MART_PRODUCT',
  IS_POS_ACTIONED = 'IS_POS_ACTIONED',
  IS_ALERT_SUCCESS = 'IS_ALERT_SUCCESS',
  IS_ALERT_FAILURE = 'IS_ALERT_FAILURE',
  PRODUCT_TOTAL_ITEMS = 'PRODUCT_TOTAL_ITEMS',
  PRODUCT_WEIGHT_UNIT = 'PRODUCT_WEIGHT_UNIT',
  PRODUCT_SIZE = 'PRODUCT_SIZE',
  PRODUCT_AMOUNT_CONFIG = 'PRODUCT_AMOUNT_CONFIG',
  PRODUCT_CALCULATED_WEIGHT = 'PRODUCT_CALCULATED_WEIGHT',
  PRODUCT_CALCULATED_SIZE = 'PRODUCT_CALCULATED_SIZE',
  PRODUCT_WEIGHT_SIZE_DATA = 'PRODUCT_WEIGHT_SIZE_DATA',
  IS_EDIT_BASKET_LIMIT = 'IS_EDIT_BASKET_LIMIT',
}

export type MartProductState = {
  [MART_PRODUCT_STATE_KEY.MART_PRODUCT]?: []
  [MART_PRODUCT_STATE_KEY.IS_POS_ACTIONED]?: boolean
  [MART_PRODUCT_STATE_KEY.IS_ALERT_SUCCESS]?: boolean
  [MART_PRODUCT_STATE_KEY.IS_ALERT_FAILURE]?: boolean
  [MART_PRODUCT_STATE_KEY.PRODUCT_TOTAL_ITEMS]?: number
  [MART_PRODUCT_STATE_KEY.PRODUCT_WEIGHT_UNIT]?: []
  [MART_PRODUCT_STATE_KEY.PRODUCT_SIZE]?: []
  [MART_PRODUCT_STATE_KEY.PRODUCT_AMOUNT_CONFIG]?: {}
  [MART_PRODUCT_STATE_KEY.PRODUCT_CALCULATED_WEIGHT]?: {}
  [MART_PRODUCT_STATE_KEY.PRODUCT_CALCULATED_SIZE]?: {}
  [MART_PRODUCT_STATE_KEY.PRODUCT_WEIGHT_SIZE_DATA]?: {}
  [MART_PRODUCT_STATE_KEY.IS_EDIT_BASKET_LIMIT]?: boolean
};

const initialState: MartProductState = {
  [MART_PRODUCT_STATE_KEY.MART_PRODUCT]: [],
  [MART_PRODUCT_STATE_KEY.IS_POS_ACTIONED]: false,
  [MART_PRODUCT_STATE_KEY.IS_ALERT_SUCCESS]: false,
  [MART_PRODUCT_STATE_KEY.IS_ALERT_FAILURE]: false,
  [MART_PRODUCT_STATE_KEY.PRODUCT_WEIGHT_UNIT]: [],
  [MART_PRODUCT_STATE_KEY.PRODUCT_SIZE]: [],
};

export const martProductReducers = (state = initialState, action: MartProductActions) => {
  switch (action.type) { // NOSONAR [typescript:S1301] followed usage pattern of reducer
    case MART_PRODUCT_ACTION_TYPE.SET_MART_PRODUCT_STATE:
      return {
        ...state,
        [action.payload.key]: action.payload.value
      };
    default:
      return state;
  }
};

export const martProductStateSelector = (key: MART_PRODUCT_STATE_KEY) => (state: RootState) => state.martProduct[key];
